import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Dimmer, Loader, Segment } from 'semantic-ui-react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { API, showError, showSuccess } from '../helpers';
import { UserContext } from '../context/User';

const GitHubOAuth = () => {
  const [searchParams] = useSearchParams();

  const [, userDispatch] = useContext(UserContext);
  const [prompt, setPrompt] = useState('处理中...');

  let navigate = useNavigate();

  const sendCode = useCallback(async (code, count) => {
    const res = await API.get(`/api/oauth/github?code=${code}`);
    const { success, message, data } = res.data;
    if (success) {
      userDispatch({ type: 'login', payload: data });
      localStorage.setItem('user', JSON.stringify(data));
      navigate('/');
      showSuccess('登录成功！');
    } else {
      showError(message);
      if (count === 3) {
        setPrompt(`登录失败，重定向至登录界面中...`);
        navigate('/login');
        return;
      }
      count++;
      setPrompt(`出现错误，第 ${count} 次重试中...`);
      await new Promise(resolve => setTimeout(resolve, count * 2000));
      await sendCode(code, count);
    }
  }, [navigate, userDispatch]);

  useEffect(() => {
    const code = searchParams.get('code');
    sendCode(code, 0).then();
  }, [searchParams, sendCode]);

  return (
    <Segment style={{ minHeight: '300px' }}>
      <Dimmer active inverted>
        <Loader size='large'>{prompt}</Loader>
      </Dimmer>
    </Segment>
  );
};

export default GitHubOAuth;
